import Vue from 'vue'
import Vuex from 'vuex'

import user from '@/store/modules/user'
import application from '@/store/modules/application/index.js'
import whitelabel from '@/store/modules/whitelabel'
import { ProfileCore } from 'profile-ts'

const version = require('@/../package.json').version

const dataCore = {
  environment: process.env.VUE_APP_CORE_ENV,
  theme: process.env.VUE_APP_THEME
}

export const ProfileInstance = new ProfileCore(dataCore)

Vue.use(Vuex)

export const catchError = function (error, dispatch) {
  if (error.status === 401) {
    dispatch('LOGOUT')
    window.location.assign(process.env.VUE_APP_ID_URL)
  }
}

export default new Vuex.Store({
  state: {
    appVersion: version,
    maintenance: false
  },
  getters: {
    appVersion (state) {
      return state.appVersion
    },
    maintenance (state) {
      return state.maintenance
    }
  },
  modules: {
    user,
    application,
    whitelabel
  }
})
